import { h } from "@stencil/core";
export class DcUiHeaderFlyoutNavLink {
    constructor() {
        this.isKeyboardEvent = false;
        this.handleClick = (event) => {
            var _a;
            // Skip if this was triggered by a keyboard event
            if (this.isKeyboardEvent) {
                this.isKeyboardEvent = false;
                return;
            }
            this.dcSubitemSelect.emit({
                origin: 'click',
                label: ((_a = this.linkElement.querySelector('span')) === null || _a === void 0 ? void 0 : _a.textContent) || this.label,
                href: this.href,
                selected: false,
                event,
                level: this.getCurrentLevel(),
            });
        };
        this.handleKeyDown = (event) => {
            var _a;
            if (event.key === 'Enter' || event.key === ' ') {
                this.isKeyboardEvent = true;
                this.dcSubitemSelect.emit({
                    origin: 'keydown',
                    label: ((_a = this.linkElement.querySelector('span')) === null || _a === void 0 ? void 0 : _a.textContent) || this.label,
                    href: this.href,
                    selected: false,
                    event,
                    level: this.getCurrentLevel(),
                });
            }
        };
        this.getCurrentLevel = () => {
            // get the level of the current item if possible
            const menuContainer = this.el.closest('.menu-container');
            let level = 'unknown';
            if (menuContainer) {
                level = menuContainer.getAttribute('data-nav-level');
            }
            return level;
        };
    }
    async focusElement() {
        this.linkElement.focus();
    }
    componentWillLoad() {
        if (!this.href) {
            this.disabled = true;
        }
    }
    render() {
        return (h("a", { key: 'b2c125f5d17817e6185ef5346c5bdf4e5a0732cc', ref: (el) => (this.linkElement = el), href: this.href, target: this.target, rel: this.rel, class: this.disabled ? 'disabled' : '', onClick: this.handleClick, onKeyDown: this.handleKeyDown }, h("span", { key: '7d44bde095d21b90458032be6b1aac9ffd24f85f' }, this.label || h("slot", { key: 'e5d39f90e74b770848ff4c83441886e5be5c74be' }))));
    }
    static get is() { return "dc-ui-header-flyout-nav-link"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-header-flyout-nav-link.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-header-flyout-nav-link.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "label",
                "reflect": false
            },
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "href",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "disabled",
                "reflect": false
            },
            "target": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "'_blank' | '_self' | '_parent' | '_top'",
                    "resolved": "\"_blank\" | \"_parent\" | \"_self\" | \"_top\"",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "target",
                "reflect": false
            },
            "rel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "rel",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "dcSubitemSelect",
                "name": "dcSubitemSelect",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "{\r\n    origin: 'click' | 'keydown';\r\n    label: string;\r\n    href: string;\r\n    selected: boolean;\r\n    event: Event;\r\n    level: number | string;\r\n  }",
                    "resolved": "{ origin: \"click\" | \"keydown\"; label: string; href: string; selected: boolean; event: Event; level: string | number; }",
                    "references": {
                        "Event": {
                            "location": "import",
                            "path": "@stencil/core",
                            "id": "node_modules::Event"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "focusElement": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dc-ui-header-flyout-nav-link.js.map
